module.exports = __webpack_public_path__ + "img/thumb@2x.e7ade25e.png";